import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';


const useStyles = createUseStyles({
  divIcon: {
    composes: ['icon'],
    height: 206,
    padding: '2rem',
    width: '100%',
  },
  i: {
    // Composition doesn't work with dynamic data at the moment
    composes: ['far', 'has-text-primary', 'has-text-centered'],
    width: '100% !important',
    fontSize: '8rem',
  },
});

const CardIcon = ({ icon }) => {
  const { divIcon, i } = useStyles();

  return (
    <div className={divIcon}>
      <i className={classNames(i, `fa-${icon}`)} />
    </div>
  );
};

export default CardIcon;
